import { graphql } from "relay-runtime"

export const chUpdateProgressNoteTreatmentPlanMutation = graphql`
  mutation chUpdateProgressNoteTreatmentPlanMutation($input: Ch_updateProgressNoteTreatmentPlanInput!) {
    updateProgressNoteTreatmentPlan: ch_updateProgressNoteTreatmentPlan(input: $input) {
      ProgressNoteMutationOutput: ch_ProgressNoteMutationOutput {
        episodeOfCare {
          id
          patientId
          updatedAt
        }
        progressNote {
          id
          updatedAt
          treatmentPlan {
            title
            from
            to
            followUpInstructions
            recommended
          }
        }
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
